/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";

import BaseSearchField from "./common/BaseSearchField";
import { updateSpotFilters, updateSpotFiltersV2 } from "../slices/spotFiltersSlice";
import defaultSpotFilter from "../helpers/defaultSpotFilters";

const SpotSearchField = () => {
  const searchTerm = useSelector((state) => state.spotFilters.searchTerm);
  const isFetching = useSelector((state) => state.spotLegs.isFetching);

  return (
    <BaseSearchField
      searchTerm={searchTerm}
      isFetching={isFetching}
      // Can delete updateSpotFilters, and the fetchSpotLegs... functions when we swap these. Only used here.
      updateFilters={updateSpotFilters} // Need to change back to updateSpotFiltersV2 when combined with filters
      placeholder={"Route code, ID, or trailer #"}
      defaultFilters={defaultSpotFilter}
      useV3Filters={false} // Need to change back to useAvailableRoutesV2Filters when combined with filters
    />
  );
};

export default SpotSearchField;
